import { Table, Drawer } from "@mantine/core";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Input } from "@mantine/core";
import { IconSearch } from "@tabler/icons";
import { useState } from "react";
import Avatar from "react-avatar";
import "../../App.css";
import { EmployeesArchiveView } from "./EmployeesArchiveDrawer/EmployeesArchiveView";
import { EmployeesArchiveEdit } from "./EmployeesArchiveDrawer/EmployeesArchiveEdit";

/*Placeholder*/
const elements = [
  {
    id: "ZS-014",
    name: "Raiden Ei",
    position: "Front-end Developer",
    team: "Technical",

    type: "Part-time (Regular)",
    date_added: "2020-07-08",
    email: "dangomilk@inazuma.com",
    phone: "639285627893",
    hourly_rate: "420",
    referred: "Zhongli Morax",
    files: "https://wdrive.com/222",
    bank: "Northland Bank",
    acc_name: "Raiden Makoto",
    acc_num: "166458954893",
  },
  {
    id: "ZS-015",
    date_added: "2020-07-09",
    name: "Raiden Makoto",
    position: "Project Manager",
    team: "Technical",

    type: "Full-time (Regular)",
    email: "makoto@inazuma.com",
    phone: "639285627894",
    basic_pay: "19420",
    referred: "Raiden Ei",
    files: "https://wdrive.com/223",
    bank: "Northland Bank",
    acc_name: "Raiden Makoto",
    acc_num: "166458954893",
  },
  {
    id: "ZS-016",
    name: "Kokomi Sangonomiya",
    team: "Technical",

    position: "UX/UI Designer",
    type: "Part-time (Project Based)",
    date_added: "2020-07-10",
    email: "divinepriestess@watatsumi.com",
    phone: "639285627993",
    hourly_rate: "420",
    referred: "Ayato Kamisato",
    files: "https://wdrive.com/224",
    bank: "Northland Bank",
    acc_name: "Kokomi Sangonomiya",
    acc_num: "166458954895",
  },
  {
    id: "ZS-017",
    name: "Hu Tao",
    team: "Technical",
    position: "Back-end Developer",
    type: "Full-time (Regular)",
    date_added: "2020-07-25",
    email: "hutao@wangsheng.com",
    phone: "639285628893",
    basic_pay: "19420",
    referred: "Zhongli Morax",
    files: "https://wdrive.com/125",
    bank: "Northland Bank",
    acc_name: "Hu Tao",
    acc_num: "166458954873",
  },
];

export function EmployeesArchiveTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [opened, setOpened] = useState(false);
  const [employeeData, setEmployeeData] = useState({});
  const [editContactId, setEditContactId] = useState(null);

  function clicked(
    empAdded,
    empName,
    empID,
    empPosition,
    empTeam,
    empType,
    empEmail,
    empPhone,
    empFile,
    empBPay,
    empHRate,
    empReferred,
    empBank,
    empAccName,
    empAccNum
  ) {
    setOpened(true);

    let empData = {};
    empData["date_added"] = empAdded;
    empData["name"] = empName;
    empData["id"] = empID;
    empData["position"] = empPosition;
    empData["team"] = empTeam;
    empData["type"] = empType;
    empData["email"] = empEmail;
    empData["phone"] = empPhone;
    empData["file"] = empFile;
    empData["basic_pay"] = empBPay;
    empData["hourly_rate"] = empHRate;
    empData["referred"] = empReferred;
    empData["bank_name"] = empBank;
    empData["acc_name"] = empAccName;
    empData["acc_num"] = empAccNum;

    let jsonString = JSON.stringify(Object.assign({}, empData));
    let json_obj = JSON.parse(jsonString);

    setEmployeeData(json_obj);
  }

  function MantineTable() {
    const rows = elements
      .filter((val) => {
        if (searchTerm === "") {
          return val;
        } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return val;
        }
      })
      .map((element) => (
        <tr key={element.name}>
          <td>
            <button
              onClick={() =>
                clicked(
                  element.date_added,
                  element.name,
                  element.id,
                  element.position,
                  element.team,
                  element.type,
                  element.email,
                  element.phone,
                  element.files,
                  element.basic_pay,
                  element.hourly_rate,
                  element.referred,
                  element.bank,
                  element.acc_name,
                  element.acc_num
                )
              }
              className="btn-text"
            >
              {element.id}
            </button>
          </td>
          <td>
            <div className="name-cell">
              <Avatar name={element.name} size="36" round={true} />
              {element.name}
            </div>
          </td>
          <td>{element.position}</td>
          <td>{element.type}</td>
        </tr>
      ));

    return (
      <Table highlightOnHover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Position</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    );
  }

  const handleEditClick = (event, employeeData) => {
    event.preventDefault();
    setEditContactId(employeeData.id);
  };

  const handleCancelClick = (event, employeeData) => {
    event.preventDefault();
    setEditContactId(null);
  };

  return (
    <>
      <Row>
        <Col>
          <Input
            icon={<IconSearch size={16} />}
            placeholder="Search..."
            radius="lg"
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
          />
        </Col>
      </Row>
      <MantineTable />
      <Drawer
        position="right"
        opened={opened}
        onClose={() => setOpened(false)}
        title="Employee Info"
        padding="xl"
        size="xl"
      >
        {editContactId === employeeData.id ? (
          <EmployeesArchiveEdit
            employeeData={employeeData}
            handleCancelClick={handleCancelClick}
          />
        ) : (
          <EmployeesArchiveView
            handleEditClick={handleEditClick}
            employeeData={employeeData}
          />
        )}
      </Drawer>
    </>
  );
}
